import en from './en.json';
import es from './es.json';
import cn from './cn.json';

export const translations = {
  en,
  es,
  cn,
} as const;

export type Language = keyof typeof translations;
export type TranslationKeys = typeof en;

export type NestedKeyOf<T> = T extends object
  ? {
      [K in keyof T]: K extends string
        ? T[K] extends object
          ? `${K}` | `${K}.${NestedKeyOf<T[K]>}`
          : `${K}`
        : never;
    }[keyof T]
  : never;

export interface TranslationVariables {
  [key: string]: string | number;
}
